import I18n from 'I18n';
import { memo, useMemo } from 'react';
import { DURATION_THRESHOLDS, IMPROVED_DURATION_THRESHOLDS, formatDuration } from 'customer-data-property-utils/utils/dateAndDateTimeFormatting';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import { useGetIsUngated } from '../v2/hooks/useGetIsUngated';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { gate } from 'hub-http/gates';
import TextInputAdapter from '../adapters/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputDuration = props => {
  const getIsUngated = useGetIsUngated();
  const isUngatedForImprovedTimeThresholds = getIsUngated(gate('CRM:PropMgmt:ImprovedTimeThresholds'));
  const {
    autoFocus,
    inputRef,
    onChange
  } = props;
  const value = usePropertyValue();
  useComponentMountMetric('PropertyInputDuration');
  const displayValue = useMemo(() => {
    const parsedValue = parseNumericValue(value);
    if (parsedValue === null) {
      return '';
    }
    return formatDuration(I18n.moment.duration(Math.abs(parsedValue)), {
      thresholds: isUngatedForImprovedTimeThresholds ? IMPROVED_DURATION_THRESHOLDS : DURATION_THRESHOLDS,
      withSuffix: false
    }, isUngatedForImprovedTimeThresholds);
  }, [isUngatedForImprovedTimeThresholds, value]);
  return /*#__PURE__*/_jsx(TextInputAdapter, Object.assign({}, getTransferrableProps(props), {
    onChange: onChange,
    autoFocus: autoFocus,
    inputRef: inputRef,
    value: displayValue || '',
    autoComplete: "off",
    readOnly: true
  }));
};
export default /*#__PURE__*/memo(PropertyInputDuration);